// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section id='customer-deposit-accounts-credit-on-us-check' class="box">
  <sub-header header="'Credit on-us check'"></sub-header>

    <!-- Product information -->
    <!-- TODO = this should be extracted as component -->
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">
          {{\$ctrl.account.productDefinition.productName}}
        </span>
      </div>
      <div class="info-detail">
        <span class="key">Available balance:</span>
        <span class="value" ng-class="{'currency--positive': \$ctrl.account.balance > 0, 'currency--negative': \$ctrl.account.balance < 0}">
          {{\$ctrl.account.balance | nxCurrency}}
        </span>
      </div>
    </div>

    <br/>

    <!-- Operation form -->

    <form name="\$ctrl.transactionForm">
      <table class="misc-transaction__table table">

        <tbody>
        <tr>
          <td>1.</td>
          <td>MICR number</td>
          <td>
            <input
              required
              type="text"
              class="check-no"
              ng-model="\$ctrl.check.micrNumber"
              ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
              ui-mask-placeholder
              ui-options="{clearOnBlur: false}"
              maxlength="64"/>
          </td>
        </tr>
        <tr>
          <td>2.</td>
          <td>Valid from</td>
          <td>
            <date output-format="date"
              ng-model="\$ctrl.check.validFrom"
              ng-required="true"></date>
          </td>
        </tr>
        <tr>
          <td>3.</td>
          <td>Amount</td>
          <td>
            <cash ng-model="\$ctrl.check.amount"
              ng-required="true"></cash>
          </td>
        </tr>
        <tr>
          <td>4.</td>
          <td>Remarks</td>
          <td>
            <input
              type="text"
              ng-model="\$ctrl.check.remarks"
              ng-required="false">
          </td>
        </tr>
        </tbody>
      </table>
      <div class="buttons">
        <button class="btn btn-warning"
                ng-click="\$ctrl.redirectBack()">
          Cancel
        </button>
        <button class="btn btn-danger"
                ng-click="\$ctrl.credit()"
                ng-disabled="\$ctrl.transactionForm.\$invalid">
          Credit check
        </button>
      </div>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/credit-on-us-check/credit-on-us-check.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;